


















































































































































































import Vue from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import config from "@/configs";
import PaymentForm from "@/components/PaymentForm.vue";
import PaymentHistoryCard from "@/components/PaymentHistoryCard.vue";
import PaymentIntentDetailsCard from "@/components/PaymentIntentDetailsCard.vue";
import CustomerCreateCardContent from "@/components/CustomerCreateCardContent.vue";

interface Data {
  selectedCustomer: string | null;
  selectedOption: string | null;
  selectedPaymentId: string | null;
  isSuccessfulPayment: boolean;
  isCreateNewCustomer: boolean;
  canMakePayments: boolean;
  canViewPaymentHistory: boolean;
  canAccessPortal: boolean;
  canCreateCustomers: boolean;
  company: string | undefined;
  isLoadingMap: any;
  customer: any | null;
}

export default Vue.extend({
  name: "CustomerCardContent",
  components: {
    CustomerCreateCardContent,
    PaymentForm,
    PaymentHistoryCard,
    PaymentIntentDetailsCard,
  },
  computed: {
    ...mapGetters("auth", ["getAuthEmailVerified", "getUserCustomers"]),
    ...mapGetters("billingPortal", {
      billingLoading: "getLoading",
    }),
    ...mapGetters("customer", {
      customerLoading: "getLoading",
    }),
  },
  created() {
    if (this.$route.query.success) {
      this.selectedCustomer = "tmp";
      this.selectedOption = "payment";
      this.isSuccessfulPayment = true;
      this.$router.push(this.$route.path);
    }
  },
  data(): Data {
    return {
      selectedCustomer: null,
      selectedOption: null,
      selectedPaymentId: null,
      isSuccessfulPayment: false,
      isCreateNewCustomer: false,
      company: config?.settings.company,
      canMakePayments: !!config?.settings?.customerSettings?.canMakePayments,
      canViewPaymentHistory:
        !!config?.settings?.customerSettings?.canViewPaymentHistory,
      canAccessPortal: !!config?.settings?.customerSettings?.canAccessPortal,
      canCreateCustomers:
        !!config?.settings?.customerSettings?.canCreateCustomers,
      isLoadingMap: {},
      customer: null,
    };
  },
  methods: {
    ...mapActions("auth", ["verifyEmailLink", "afterLogin"]),
    ...mapActions("billingPortal", ["navigateToBillingPortal"]),
    ...mapActions("customer", ["fetchCustomer"]),
    ...mapMutations("customer", ["setSelectedCustomerId"]),
    onCreatedCustomer() {
      this.afterLogin();
    },
    async onSelectCustomer(id: string) {
      this.selectedCustomer = id;
      this.setSelectedCustomerId(id);
    },
    getTitle() {
      if (this.selectedOption) {
        return this.$t(`customers.options.${this.selectedOption}.title`);
      } else if (this.selectedCustomer) {
        return this.$t("customers.profileOptions");
      } else if (!this.isSuccessfulPayment) {
        return this.$t("customers.selectAProfile");
      }
    },
    goBack() {
      if (this.selectedOption === "paymentDetails") {
        this.selectedOption = "paymentHistory";
        return;
      }
      if (this.isCreateNewCustomer) {
        this.isCreateNewCustomer = false;
      } else if (this.isSuccessfulPayment) {
        this.isSuccessfulPayment = false;
        this.selectedOption = null;
        this.selectedCustomer = null;
      } else if (this.selectedOption) {
        this.selectedOption = null;
      } else if (this.selectedCustomer) {
        this.selectedCustomer = null;
      }
    },
    async onManageProfile() {
      const payload = {
        customer: this.selectedCustomer,
        return_url: window.location.href,
      };

      await this.navigateToBillingPortal(payload);
    },
    setIsLoadingMap(id: string, value: boolean) {
      this.isLoadingMap = {
        ...this.isLoadingMap,
        [id]: value,
      };
    },
  },
});
